// extracted by css-extract-rspack-plugin
export default {"spaceMedium":"20px","spaceFluid":"100%","identificationFlow":"identification-flow__identificationFlow___G9WGS","identityCard":"identification-flow__identityCard___FhLtX"};